import angular from 'angular'

import CarouselComponent from './vd-carousel.component'
import CarouselFrameComponent from './vd-carousel-frame.component'

angular
  .module('vend.ui')
  .component('vdCarousel', CarouselComponent)
  .component('vdCarouselFrame', CarouselFrameComponent)
